(function($) {

	'use strict';

	var init = function() {

		if($('section').hasClass( "hero" )) {
			var observer = new IntersectionObserver(function(entries) {
				// no intersection with screen
				if(entries[0].intersectionRatio === 0)
					document.querySelector(".header__secondary__container").classList.remove("header__hidden");
				// fully intersects with screen
				else if(entries[0].intersectionRatio === 1)
					document.querySelector(".header__secondary__container").classList.add("header__hidden");
			}, { threshold: [0,1] });
			
			observer.observe(document.querySelector(".hero"));
		}
		
		openMenu();
	};
	

	var openMenu = function() {

		$('.header__burger').click(function() {
			$(this).toggleClass('active');
			$('.header__mobile').toggleClass('active');
			$('.header__secondary__nav__phone').toggleClass('hidden');
			$('body').toggleClass('open');
		})

		$('.header__mobile__nav__main > ul > li > a').click(function() {
			$('.header__burger').toggleClass('active');
			$('.header__mobile').toggleClass('active');
			$('.header__secondary__nav__phone').toggleClass('hidden');
			$('body').toggleClass('open');
		})
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
